// One colour convention for results across Genetics, Wellbeing, Epigenetics and Blood tests:
// green = good, blue = normal, amber = not so good. The same values are in resultColors.scss.
export const RESULT_COLORS = {
    good:   "#10A36B",
    normal: "#154096",
    poor:   "#E39A1C",
};
